import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { IListLayoutAccessibility } from 'src/app/models/interfaces/list-layout-accessibility.interface';
import { IListLayout } from 'src/app/models/interfaces/list-layout.interface';
import { ListLayoutColumn } from 'src/app/models/list-layout-column';
import { ListLayoutBoxesAccessibilityFormComponent } from '../list-layout-boxes-accessibility-form/list-layout-boxes-accessibility-form.component';
import { ListLayoutBoxesColumnsFormComponent } from '../list-layout-boxes-columns-form/list-layout-boxes-columns-form.component';
import { ListLayoutBoxesDetailContext } from '../list-layout-boxes-detail-context';
import { ListLayoutBoxesFormComponent } from '../list-layout-boxes-form/list-layout-boxes-form.component';

@Component({
    selector: 'app-list-layout-boxes-detail',
    templateUrl: './list-layout-boxes-detail.component.html',
    styleUrls: ['./list-layout-boxes-detail.component.scss'],
    imports: [MatTabsModule, ListLayoutBoxesFormComponent, ListLayoutBoxesColumnsFormComponent, FaIconComponent, ListLayoutBoxesAccessibilityFormComponent]
})
export class ListLayoutBoxesDetailComponent implements OnInit {
    public warningIcon = faTriangleExclamation;
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public listLayoutUpdated: EventEmitter<IListLayout> = new EventEmitter();

    /**
     * Emis lorsque le formulaire d'accessibilité est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public accessibilitiesUpdated: EventEmitter<IListLayoutAccessibility[]> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Contexte du formulaire.
     */
    public _context: ListLayoutBoxesDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<ListLayoutBoxesDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: ListLayoutBoxesDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    public totalColumnSize: number;

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param listLayout: Infos du listLayout modifié.
     */
    public onListLayoutUpdated(listLayout: IListLayout) {
        this.listLayoutUpdated.emit(listLayout);
    }

    public onListLayoutColumnsUpdated(listLayoutColumns: ListLayoutColumn[]) {
        if (this._context.formContext.item.isScreenSizeAdapted) {
            let sumColumnSize = 0;
            listLayoutColumns.forEach((x) => (sumColumnSize += x.size));
            this.totalColumnSize = sumColumnSize;
        }
    }

    public onListLayoutColumnsRefreshed(listLayoutColumns: ListLayoutColumn[]) {
        if (listLayoutColumns) {
            let sumColumnSize = 0;
            listLayoutColumns.forEach((x) => (sumColumnSize += x.size));
            this.totalColumnSize = sumColumnSize;
        }
    }

    /** Appellé lorsque des changements sur le formulaire "Accessibilité" sont sauvegardés.*/
    public onAccessibilitiesUpdated(accessibilities: IListLayoutAccessibility[]) {
        this.accessibilitiesUpdated.emit(accessibilities);
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param user: Infos de l'article modifié.
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
